var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIntentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94071 5.00038L9.45874 8.5216C9.71898 8.78207 9.71879 9.20418 9.45832 9.46441C9.19785 9.72464 8.77574 9.72445 8.51551 9.46398L4.9972 5.94249L1.47073 9.46371C1.21019 9.72387 0.788076 9.72356 0.52792 9.46301C0.267764 9.20247 0.268078 8.78036 0.528621 8.5202L4.05481 4.99925L0.530108 1.47135C0.269876 1.21089 0.270067 0.788777 0.530534 0.528545C0.791001 0.268313 1.21311 0.268504 1.47334 0.528972L4.99832 4.05714L8.51563 0.545058C8.77618 0.284902 9.19829 0.285216 9.45844 0.545759C9.7186 0.806302 9.71828 1.22841 9.45774 1.48857L5.94071 5.00038Z",
    fill: "#44444F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIntentImage);
export default __webpack_public_path__ + "static/media/closeIntentImage.afdab78f123214cb90e8d59907fcc39f.svg";
export { ForwardRef as ReactComponent };